export default __webpack_public_path__ + "static/media/right_arrow_active.ca5b5b54.svg";